// Google Analytics Tracking ID
// https://github.com/truethari/reactfolio#-google-analytics
export const TRACKING_ID = "G-XM54ECS9NW";
